import React from 'react';
import SortTable from '../SortTable';
import ListResults from '../ListResults';
import Icon from '../Icon';
import { Link } from 'react-router';
import svgEdit from '../../svgs/edit.svg';
import filter from "../../filter";
import LinkComp from "../LinkComp";
import plus from "../../svgs/plus-white.svg";
import { ApolloConsumer } from '@apollo/client';
import { GET_USER_LIST } from '../Graphql/UserQueries/userquaries';
import { fetchData } from '../Service/graphQlService';
import shallowEqual from 'shallowequal';
const limit = 50;

export default class UserList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: null,
            totalCount: null,
            error: null,
            isBusy: null,
        };
        this.client = null
    }

    componentDidMount() {
        if (this.client) {
            this.fetch(this.props.location.query);
        }
    }

     componentDidUpdate(prevProps) {
            if (!shallowEqual(prevProps.location.query, this.props.location.query)) {
                this.fetch(this.props.location.query);
            }
        }

    parseSortOptions(orderQuery) {
        if (orderQuery && Array.isArray(orderQuery)) {
            return orderQuery.map((item, index) => {
                const [field, order] = item.split('.');
                return {
                    field: field.toLowerCase(),
                    order: order.toLowerCase()
                };
            });
        }
        else if (orderQuery) {
            const [field, order] = orderQuery.split('.');
            return [{
                field: field.toLowerCase(),
                order: order.toLowerCase()
            }];
        }
        else{
            return [];
        }

    }

parseFilterOptions(query) {
  const filters = [];

  if (query) {
    for (const key in query) {
      if (key !== 'order' && key !== 'page' && query[key]) {
        filters.push({
          field: key,
          value: query[key]
        });
      }
    }
  }

  return filters.length > 0 ? filters : [];
}


    fetch(q) {
        this.setState({ isBusy: true });

        const query = { ...q };
        const options = filter(query, 'user');
        options.param.limit = limit;
        options.param.offset = query.page ? ((Number(query.page) - 1) * limit) : 0;

        var pageParams = {
            page: query.page ? Number(query.page) : 1,
            pageSize: limit
        }
        // Promise.all([
        //     executeQuery({ queryName: TENANTS_LIST, options: options }),
        //     executeQuery({ queryName: TENANTS_LIST_COUNT, options: options })
        // ]).then(res => {
        //     this.setState({
        //         items: res[0].data,
        //         totalCount: res[1].success && res[1].data[0] ? Number(res[1].data[0].TOTAL_COUNT) : false,
        //         error: res[0].success ? null : res[0].message,
        //         isBusy: null,
        //     });
        // });
        const sortOptions = this.parseSortOptions(q.order);
        const filterOptions = this.parseFilterOptions(q);
        if (this.client) {
        fetchData(GET_USER_LIST, {pageOptions: pageParams, filters:filterOptions, sortOptions: sortOptions })
                       .then(res => {
                           this.setState({
                               items: res.data.getUsers.users,
                               totalCount: res.data.getUsers.totalCount,
                               error: null,
                               isBusy: null,
                           });
                       })
                       .catch(err => {
                           this.setState({
                               error: err.message, 
                               isBusy: null,
                           });
                       });
        
        }
    }
    

  

    render() {
        const query = this.props.location.query;
        const columns = [
            {
                name: 'View',
                textAlign: 'center',
                columnStyle: { width: 70 },
                render: (el) => {
                    const basePath = arc.path.base.endsWith('/') ? arc.path.base.slice(0, -1) : arc.path.base;
                    const currentSearch = window.location.search;
                    const currentPath = window.location.pathname + currentSearch;
                    return (
                      <Link to={{
                        pathname: `${basePath}/users/${el.id}`,
                        state: { fromListUrl: currentPath }
                      }}>
                        <Icon svg={svgEdit} />
                      </Link>
                    );
                  }
            },
            // {
            //     code: 'NAME',
            //     name: 'Tenant',
            //     render: (el) => el.name,
            // },
            {
                code: 'username',
                name: 'User Name',
                render: (el) => el.username,
            },
            // {
            //     code: 'ADDRESS',
            //     name: 'Address',
            //     render: (el) => el.address,
            // },
            // {
            //     code: 'CITY',
            //     name: 'City',
            //     render: (el) => el.city,
            // },
            // {
            //     code: 'STATE',
            //     name: 'State',
            //     render: (el) => el.state,
            // },
            {
                code: 'email',
                name: 'EMAIL',
                render: (el) => el.email,
            },
             {
                code: 'type_code',
                name: 'User TYPE',
                render: (el) => el.type_code,
            },

            {
                code: 'user_type',
                name: 'Extended Properties (User Type)',
                render: (el) => el.user_type,
            },
             {
                code: 'status_code',
                name: 'Status',
                render: (el) => el.status_code,
            },
              {
                code: 'created_date',
                name: 'Created Date',
                 render: (el) => {
        const date = new Date(el.created_date);
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        const yyyy = date.getFullYear();
        return `${mm}-${dd}-${yyyy}`;
    },
            },
        ];

        return (
            <ApolloConsumer>
                {client => {
                    if (!this.client) {
                        this.client = client;
                    }
                    return (
                        <div className='LenderList' data-is-busy={this.state.isBusy}>
                            <div className='page-rounded-corner-container'>
                                <div className='page-header-container list'>
                                    <div className='page-header list'>
                                        <div className='page-title'>Users</div>
                                        {/* <LinkComp to={`${arc.path.base}tenant`}>
                                            <div className="button-new plus positive">
                                                <Icon svg={plus} />
                                            </div> */}
                                             <LinkComp
                                            to={{
                                                pathname: `${arc.path.base}users`,
                                                state: { fromListUrl: window.location.pathname + window.location.search }
                                            }}
                                        >
                                            <div className="button-new plus positive">
                                                <Icon svg={plus} />
                                            </div>
                                        </LinkComp>
                                    </div>
                                    <div className='line' />
                                </div>
                            </div>
                            <div className='page-body-container' >
                                <SortTable columns={columns}
                                    items={this.state.items}
                                    query={query}
                                />
                                <ListResults query={this.props.location.query}
                                    pathname={this.props.location.pathname}
                                    error={this.state.error}
                                    totalCount={this.state.totalCount}
                                    itemCount={this.state.items ? this.state.items.length : false}
                                    limit={limit}
                                />
                            </div>
                        </div>
                    )
                }}
            </ApolloConsumer>
        );
    }
}